import React, { useEffect } from "react";
import "../style/page/HomePage.css";
import Card from "../component/HomePage/Card";
import LogoStrip from "../component/HomePage/LogoStrip";
import { useCardInteractions, useLogoStripCarousel } from "../hooks/websiteHooks";
import { useHomePageContent } from "../hooks/useHomePageContent";

function HomePage() {
  const { title, description, metaTitle, cards, logoStrips } = useHomePageContent();

  // Initialize homepage-specific features
  useCardInteractions([cards.length]);
  useLogoStripCarousel([logoStrips.length]);

  useEffect(() => {
    if (metaTitle) {
      document.title = metaTitle;
    }
  }, [metaTitle]);

  return (
    <main className="main-content home-page">
      <h1 className="page-title">{title}</h1>

      <p className="description">{description}</p>

      <Card items={cards} />

      {logoStrips.map((section) => (
        <LogoStrip key={section.id} id={section.slug} title={section.title} items={section.items} />
      ))}
    </main>
  );
}
export default HomePage;
